import React, { useState } from 'react';
import Lottie from 'lottie-react';
import './App.css';
import valentinesAnimation from "./Valentines Day.json";
import confettiAnimation from "./Confetti.json";

function App() {
  const [name] = useState('Miss Shivani');
  const [yesClicked, setYesClicked] = useState(false);
  const [noButtonStyle, setNoButtonStyle] = useState({});
  const [showAnimation, setShowAnimation] = useState(false);

  const handleNoClick = (e) => {
    // Prevent default behavior to avoid focus/click states
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    // Button dimensions estimate: width ~180px, height ~60px, plus safety margin
    const buttonWidth = 200;
    const buttonHeight = 80;
    const margin = 20;

    // Calculate safe boundaries
    const maxX = window.innerWidth - buttonWidth - margin;
    const maxY = window.innerHeight - buttonHeight - margin;

    // Ensure minimum position (margin from edges)
    const minX = margin;
    const minY = margin;

    // Generate random position within safe boundaries
    const x = Math.random() * (maxX - minX) + minX;
    const y = Math.random() * (maxY - minY) + minY;

    setNoButtonStyle({ position: 'fixed', left: `${x}px`, top: `${y}px`, zIndex: 100 });
  };

  const handleYesClick = () => {
    setShowAnimation(true);
    setTimeout(() => {
      setShowAnimation(false);
      setYesClicked(true);
    }, 3000); // 3 seconds
  };

  return (
    <div className="App">
      <header className="App-header">
        <div className="floating-hearts">
          <div className="heart-float" style={{ left: '10%', animationDelay: '0s' }}>💕</div>
          <div className="heart-float" style={{ left: '20%', animationDelay: '2s' }}>❤️</div>
          <div className="heart-float" style={{ left: '30%', animationDelay: '4s' }}>💖</div>
          <div className="heart-float" style={{ left: '70%', animationDelay: '1s' }}>💗</div>
          <div className="heart-float" style={{ left: '80%', animationDelay: '3s' }}>💝</div>
          <div className="heart-float" style={{ left: '90%', animationDelay: '5s' }}>💘</div>
        </div>

        <div className="content">
          {showAnimation ? (
            <Lottie animationData={confettiAnimation} loop={true} style={{ height: 400, zIndex: 10 }} />
          ) : yesClicked ? (
            <div className="success-container">
              <p>Yayy!!! See you soon. 💝</p>
              <video
                width="400"
                height="400"
                autoPlay
                controls
                loop
              >
                <source src="/video.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          ) : (
            <div className="question-container">
              <h1>{name}, will you be my valentine ?</h1>
              <Lottie animationData={valentinesAnimation} style={{ height: 250 }} />
              <div className="buttons">
                <button className="yes-button" onClick={handleYesClick}>
                  Yes 💖
                </button>
                <button
                  className="no-button"
                  style={noButtonStyle}
                  onMouseOver={handleNoClick}
                  onTouchStart={handleNoClick}
                  onFocus={(e) => e.target.blur()}
                >
                  No
                </button>
              </div>
            </div>
          )}
        </div>
      </header>
    </div>
  );
}

export default App;
